var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{attrs:{"tag":"a","href":_vm.document.SignedUrl,"icon-left":"cloud-download-alt"}},[_vm._v("\n    Download\n")])}
var staticRenderFns = []

export { render, staticRenderFns }